import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import CollaboratorRow from './CollaboratorRow';
import type { Collaborator } from '../../types/api';

interface AllCollaboratorsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  collaborators: Collaborator[];
  onPersonClick: (personId: number, e: React.MouseEvent) => void;
  onProjectClick: (projectId: number, e: React.MouseEvent) => void;
}

export default function AllCollaboratorsSheet({
  open,
  onOpenChange,
  collaborators,
  onPersonClick,
  onProjectClick,
}: AllCollaboratorsSheetProps) {
  const { t } = useTranslation('person');

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-lg flex flex-col gap-0 p-0"
      >
        <SheetHeader className="px-6 pt-6 pb-4">
          <SheetTitle>{t('allCollaboratorsSheet.title')}</SheetTitle>
          <SheetDescription>{t('allCollaboratorsSheet.description')}</SheetDescription>
        </SheetHeader>

        <Separator />

        <ScrollArea className="flex-1">
          <div className="px-6 py-6">
            {collaborators.length === 0 ? (
              <p className="text-center text-sm text-ctu-text-muted py-10">
                {t('collaboratorsSection.noCollaborators')}
              </p>
            ) : (
              <ol className="m-0 flex flex-col divide-y divide-border list-none p-0">
                {collaborators.map((c, idx) => (
                  <CollaboratorRow
                    key={c.id}
                    collaborator={c}
                    index={idx}
                    showIndex
                    onPersonClick={(id, e) => {
                      onPersonClick(id, e);
                      onOpenChange(false);
                    }}
                    onProjectClick={(id, e) => {
                      onProjectClick(id, e);
                      onOpenChange(false);
                    }}
                  />
                ))}
              </ol>
            )}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
